<div class="menu-container geometriesmenu">
@if(loading===true) {
    <rask-busy-spinner size="1"></rask-busy-spinner>
}
<div style="max-height: 40vh; overflow-y: auto;">
    <div>
    <table style="width: 100%">
        @for (gi of geometries; track gi) {
        <tr [ngbTooltip]="gi.tooltip">
            <td>
            <rask-checkbox style="height: 16px; width: 100%" [text]="getShortLabel(gi.label)"
                (change)="geometryChecked(gi, $event)"
                [ngModel]="gi.checked">
            </rask-checkbox>
            </td>
            <td>
            <rask-icon-button (click)="closeGeometry(gi)" icon="fal fa-times">
            </rask-icon-button>
            </td>
        </tr>
        }
    </table>
    </div>
</div>
@if (hasSelected()) {
    <div>
    <rask-icon-button [disabled]="!canZoom()" (click)="zoomToSelected()" ngbTooltip="Zooma till"
    icon="fal fa-expand-arrows"></rask-icon-button>
    <rask-icon-button [disabled]="!canCopy()" (click)="copy()" ngbTooltip="Kopiera"
    icon="fal fa-copy"></rask-icon-button>
    <rask-icon-button [disabled]="!canPaste()" (click)="paste()" ngbTooltip="Klistra in"
    icon="fal fa-paste"></rask-icon-button>
    <rask-icon-button [disabled]="!canMerge()" (click)="merge()" ngbTooltip="Slå ihop"
        icon="fal fa-object-group">
    </rask-icon-button>
    <rask-icon-button [disabled]="!canEdit()" (click)="edit()" ngbTooltip="Redigera" icon="fal fa-edit">
    </rask-icon-button>
    </div>
}
@if (hasSelected()) {
    <div>
    <rask-information-popup [data]="checkedGeoInfo"></rask-information-popup>
    </div>
}
</div>
